import { FiArrowLeft } from "@react-icons/all-files/fi/FiArrowLeft";
import React, { FunctionComponent } from "react";

import { BackLink } from "../Text";

interface ReportBackLinkProps {
  text: string;
  hide: boolean;
  onClick: () => void;
}

export const ReportBackLink: FunctionComponent<ReportBackLinkProps> = ({
    text,
    hide,
    onClick,
}) => {
    return (
        <>
            {!hide && (
                <BackLink
                    onClick={onClick}
                    style={{
                        marginBottom: "15px",
                    }}
                >
                    <FiArrowLeft size={14} />
                    {text}
                </BackLink>
            )}
        </>
    );
};
